// extracted by mini-css-extract-plugin
export default {"productGallery":"gL-z","inQuickShop":"hL-z"};